document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-twins-menu-toggle]');
  const menu = document.querySelector('[data-twins-menu]');
  if (!toggle || !menu) return;

  const closeMenu = () => {
    menu.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = '☰';
  };

  toggle.addEventListener('click', () => {
    const open = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
    toggle.textContent = open ? '×' : '☰';
  });

  menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
});

(function () {
  const start = () => {
    const header = document.querySelector('.twins-site-header--overlay');
    if (!header) return;
    const home = document.querySelector('.twins-home');
    let queued = false;
    const check = () => {
      queued = false;
      const top = home ? home.getBoundingClientRect().top : 0;
      header.classList.toggle('is-stuck', top < -8);
    };
    const queue = () => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(check);
    };
    // capture: true also catches scrolling inside the theme's page wrapper, not just the window
    document.addEventListener('scroll', queue, { passive: true, capture: true });
    window.addEventListener('resize', queue);
    window.addEventListener('pageshow', queue);
    check();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
